import { createReducer } from '@reduxjs/toolkit';

import { IFlipbook } from './interfaces';
import * as actions from './actions';

const initialState: IFlipbook = {
  count: -1,
  currentPage: -1,
  visiblePages: [],
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.setCount, (state, action) => {
    state.count = action.payload.count;
  })
  .addCase(actions.updateState, (state, action) => {
    if (action.payload.count) {
      state.count = action.payload.count;
    }
    state.currentPage = action.payload.currentPage;
    state.visiblePages = action.payload.visiblePages;
  }));
